/* eslint-disable no-unmodified-loop-condition,no-extend-native,no-undef */
'use strict'

import * as qiniu from 'qiniu-js'
import {getUploadToken} from '@/services/common_api'

export function checkPhone (val) {
  // var filter = /^1\d{10}$/
  let filter = /^[1-9]{2}[0-9]{9}$/
  return !!filter.test(val)
}

export function checkIdCardNo (val) {
  let filter = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return !!filter.test(val)
}

/**
 *   对Date的扩展，将 Date 转化为指定格式的String
 *   月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *   例子：
 *   (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *   (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export function fmtDate (date, fmt) { // author: meizz
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 由于moment库加进来太大了，自定义了formnow函数，待完善阶段
 * @return {string}
 */
export function fromNow (msd) {
  let time = parseFloat(msd) / 1000
  let str = ''
  if (time != null && time !== '') {
    if (time > 60 && time < 3600) {
      str = parseInt(time / 60.0) + ' 分钟前'
    } else if (time >= 3600 && time < 86400) {
      str = parseInt(time / 3600.0) + ' 小时前'
    } else if (time >= 86400 && time < 86400 * 30) {
      str = parseInt(time / 86400.0) + ' 天前'
    } else if (time >= 86400 * 30 && time < 86400 * 365) {
      str = parseInt(time / (86400.0 * 30)) + ' 个月前'
    } else if (time >= 86400 * 365) {
      str = parseInt(time / (86400.0 * 365)) + ' 年前'
    } else {
      str = parseInt(time) + ' 秒前'
    }
  }
  return str
}

export function getCurrentApiHost () {
  let hostname = location.hostname
  if (hostname.indexOf('-test') > 0 || hostname.indexOf('localhost') === 0) {
    return 'https://api-test.xmonster.cn'
    // return 'https://api.xmonster.cn'
  } else {
    return 'https://api.xmonster.cn'
  }
}

export function getCurrentSvcApiHost () {
  let hostname = location.hostname
  if (hostname.indexOf('test.xmonster.cn') > -1) {
    return 'https://api-test.xmonster.cn'
  } else if (hostname.indexOf('xmonster.cn') > -1) {
    return 'https://api.xmonster.cn'
  }
  return 'http://api-v1-svc.app.svc.cluster.local:8801'
}

export function getCurrentSvcApiV2Host () {
  let hostname = location.hostname
  if (hostname.indexOf('test.xmonster.cn') > -1) {
    return 'https://api-test.xmonster.cn'
  } else if (hostname.indexOf('xmonster.cn') > -1) {
    return 'https://api.xmonster.cn'
  }
  return 'http://api-v2-svc.app.svc.cluster.local:9100'
}

export function getCurrentMHost () {
  let hostname = location.hostname
  if (hostname.indexOf('-test') > 0 || hostname.indexOf('localhost') === 0) {
    return 'https://m-test.xmonster.cn'
    // return 'https://m.xmonster.cn'
  } else {
    return 'https://m.xmonster.cn'
  }
}

export function getCurrentSvcMHost () {
  let hostname = location.hostname
  if (hostname.indexOf('-test') > 0 || hostname.indexOf('localhost') === 0) {
    return 'https://m-test.xmonster.cn'
  } else if (hostname.indexOf('xmonster') > -1) {
    return 'https://m.xmonster.cn'
  }
  return 'http://mobile-svc.app.svc.cluster.local:8801'
}

export function reportUrl (url) {
  let img = new Image()
  img.onload = img.onerror = function () {
    img = null
  }
  img.src = getCurrentMHost() + '/vt_report?url=' + encodeURIComponent(url)
}

export function trackKV (params) {
  let img = new Image()
  img.onload = img.onerror = function () {
    img = null
  }
  let trackUrl = 'http://k8s-log-ce7c5f1013ce14f9eb38f955562b0e9ad.cn-hangzhou.log.aliyuncs.com/logstores/mobile-track-log/track?APIVersion=0.6.0'
  let deviceInfo = {
    user_agent: encodeURIComponent(navigator.userAgent),
    device_id: tryGetDeviceId()
  }
  params = {...params, ...deviceInfo}
  let trackParam = Object.keys(params).map(key => key + '=' + params[key]).join('&')
  trackUrl = `${trackUrl}&${trackParam}`
  img.src = trackUrl
}

export function isDeviceInApp () {
  return (/LetsGo/i).test(navigator.userAgent) || (/XmonsterAndroid/i).test(navigator.userAgent)
}

export function isDeviceInMiniProgramWebview () {
  return (/miniProgram/i).test(navigator.userAgent)
}

export function isDeviceInAndroid () {
  return (/LetsGo/i).test(navigator.userAgent) && (/XmonsterAndroid/i).test(navigator.userAgent)
}

export function isDeviceInIOS () {
  return (/LetsGo/i).test(navigator.userAgent) && !(/XmonsterAndroid/i).test(navigator.userAgent)
}

export function isDeviceInWeixin () {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

export function isDeviceAndroid () {
  return /android/i.test(navigator.userAgent)
}

export function isDeviceiPhone () {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}

export function filterWebp (url) {
  if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
      return this.indexOf(suffix, this.length - suffix.length) !== -1
    }
  }

  if (/android/i.test(navigator.userAgent)) {
    if (url.endsWith('webp')) {
      return url
    }
    return url + '-owebp'
  }

  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    if (url.endsWith('.webp')) {
      return url + '?imageView2/0/format/jpg'
    } else if (url.endsWith('-owebp')) {
      return url.replace('-owebp', '')
    }
  }
  return url
}

export function webThumbnailParam (url, width, height) {
  if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
      return this.indexOf(suffix, this.length - suffix.length) !== -1
    }
  }

  if (url.lastIndexOf('xmonster') > -1 || url.lastIndexOf('zhoumozuosha') > -1) {
    url = url.replace('-owebp', '')
    if (url.endsWith('-pre')) {
      return url
    }
    if (url.endsWith('.webp')) {
      return url + '?imageView2/1/w/' + width + '/h/' + height + '/format/jpg'
    } else {
      return url + '?imageView2/1/w/' + width + '/h/' + height
    }
  }
  return url
}

export function webThumbnailParamHttp (url, width, height) {
  let httpUrl = webThumbnailParam(url, width, height)
  return httpUrl.replace('https', 'http')
}

export function getOriginUrl (url) {
  if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
      return this.indexOf(suffix, this.length - suffix.length) !== -1
    }
  }

  url = url.replace('http://', 'https://').replace('-owebp', '').replace('-twebp', '')
  if (url.endsWith('.webp')) {
    return url + '?imageView2/0/format/jpg'
  }
  return url
}

export function webThumbnail400x400 (url) {
  return webThumbnailParam(url, 400, 400)
}

export function cmpVersion (leftVersion, rightVersion) {
  let localVersionArray = leftVersion.split('.').map(v => parseInt(v))
  let toCmpVersionArray = rightVersion.split('.').map(v => parseInt(v))
  let versionLength = toCmpVersionArray.length > localVersionArray.length ? localVersionArray.length : toCmpVersionArray.length
  for (let i = 0; i < versionLength; i++) {
    if (localVersionArray[i] > toCmpVersionArray[i]) {
      return 1
    } else if (localVersionArray[i] < toCmpVersionArray[i]) {
      return -1
    }
  }
  return 0
}

export function cmpLetsgoVersion (version) {
  if (!version) {
    return false
  }
  if (!isDeviceInApp()) {
    return false
  }
  let localVersionMatch = navigator.userAgent.match(/letsgo&([\w.]+)&/i)
  if (!localVersionMatch) {
    return false
  }
  return cmpVersion(localVersionMatch[1], version)
}

export function iosGTE (version) {
  return isDeviceInIOS() && cmpLetsgoVersion(version) >= 0
}

export function androidGTE (version) {
  return isDeviceAndroid() && cmpLetsgoVersion(version) >= 0
}

export function filterText (text) {
  return text.replace(/\n/g, '<br/>')
}

export function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export function createCookie (name, value, days) {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

export function readCookie (name) {
  let nameEQ = name + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function tryGetDeviceId () {
  let cookieName = 'go-device-id'
  let cookieValue = readCookie(cookieName)
  if (!cookieValue) {
    createCookie(cookieName, 'go_guid_' + guid(), 365)
    cookieValue = readCookie(cookieName)
  }
  return cookieValue.replace(/-/g, '_')
}

export function loadJSAsync (url) {
  return new Promise(resolve => loadJS(url, resolve))
}

export async function sleep (value) {
  return new Promise(resolve => setTimeout(resolve, value))
}

export function formatViewCount (value) {
  if (value > 10000) {
    // return (value / 10000).toFixed(1) + '万'
    return (Math.floor(value / 1000) / 10).toFixed(1) + '万'
  } else {
    return value
  }
}

// eslint-disable-next-line camelcase
export function getCurrentPINGXX_ID () {
  let hostname = location.hostname
  if (hostname.indexOf('-test') > 0 || hostname.indexOf('localhost') === 0) {
    return 'app_bfT4CKfzbzn55aDe'
  } else {
    return 'app_4mvjnLL8COaTe9G8'
  }
}

export function transformTimestampToDate (timestamp) {
  let date = new Date(timestamp)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
  let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return `${Y}${M}${D}${h}${m}${s}`
}

export function getZhouJi (day) {
  return '日一二三四五六'.charAt(new Date(day).getDay())
}

export function formatTimestamp (timestamp) {
  var datetime = new Date()
  datetime.setTime(timestamp * 1000)
  var year = datetime.getFullYear()
  var month = datetime.getMonth() + 1
  var date = datetime.getDate()
  let result = `${year}-`
  if (month > 9) {
    result += month
  } else {
    result += `0${month}`
  }

  result += '-'
  if (date > 9) {
    result += date
  } else {
    result += `0${date}`
  }
  return result
}

export function getRandomInt (max) {
  return Math.floor(Math.random() * Math.floor(max))
}

export function isDeviceInMiniProgram () {
  return window.__wxjs_environment === 'miniprogram'
}

export function isEmoji (str) {
  return str.match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) != null
}

export function getWeekday (date) {
  let weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  if (/(iPhone|iPad|iPod|iOS|AppleWebKit)/i.test(navigator.userAgent)) {
    date = date.replace(/-/g, '/')
  }
  return weekdays[new Date(date).getDay()]
}

export function throttle (fn, gapTime) {
  let _lastTime = null

  return function () {
    let _nowTime = +new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn()
      _lastTime = _nowTime
    }
  }
}

export function uuidv4 () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line one-var
    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function uploadImage (file) {
  return new Promise((resolve, reject) => {
    getUploadToken().then(result => {
      const config = {
        useCdnDomain: true
      }
      const fileName = uuidv4()
      let observable = qiniu.upload(file, fileName, result.token, {}, config)
      const observer = {
        next (res) {},
        error (err) {
          reject(err)
        },
        complete (res) {
          let hostname = location.hostname
          let url = ''
          if (hostname.indexOf('-test') > 0 || hostname === 'localhost') {
            url = `https://pan2.xmonster.cn/${res.key}`
          } else {
            url = `https://pan1.xmonster.cn/${res.key}`
          }
          console.log(url)
          resolve(url)
        }
      }
      observable.subscribe(observer)
    }).catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/libs/utils.js